import React, { useEffect, useRef } from "react"

const Spotlight: React.FC = () => {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const el = ref.current
    if (!el) return
    if (typeof window === "undefined") return

    if (window.matchMedia("(hover: none)").matches) return
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return

    let raf = 0
    let pendingX = 50
    let pendingY = 50

    const onMove = (e: MouseEvent) => {
      pendingX = (e.clientX / window.innerWidth) * 100
      pendingY = (e.clientY / window.innerHeight) * 100
      if (raf) return
      raf = requestAnimationFrame(() => {
        el.style.setProperty("--spot-x", `${pendingX}%`)
        el.style.setProperty("--spot-y", `${pendingY}%`)
        raf = 0
      })
    }

    window.addEventListener("mousemove", onMove, { passive: true })
    return () => {
      window.removeEventListener("mousemove", onMove)
      if (raf) cancelAnimationFrame(raf)
    }
  }, [])

  return <div ref={ref} className="spotlight" aria-hidden="true" />
}

export default React.memo(Spotlight)
